<template>
    <div class="tw:space-y-6">
        <div class="tw:mb-4 tw:px-6">
            <h2 class="tw:text-sm tw:font-semibold tw:text-gray-500 tw:uppercase tw:tracking-wide tw:my-1">Indumentarias</h2>
            <p class="tw:text-xs tw:font-semibold tw:text-gray-400 tw:my-1">Equipamiento asignado al deportista</p>
        </div>

        <div v-if="indumentarias && indumentarias.length > 0">
            <SimpleTable
                :flat="true"
                :columns="columns"
                :data="indumentarias"
                empty-text="Este deportista no ha adquirido ninguna indumentaria"
                :default-col-width="defaultColWidth"
            >
                <template #cell-cantidad="{ row }">
                    {{ row.pivot ? row.pivot.cantidad : '-' }}
                </template>

                <template #cell-talla="{ row }">
                    {{ row.talla ? row.talla.nombre : '-' }}
                </template>

                <template #cell-incluida="{ row }">
                    <span v-if="row.incluida" class="tw:text-green-600">
                        <i class="fas fa-check-circle"></i>
                    </span>
                    <span v-else class="tw:text-red-500">
                        <i class="fas fa-times-circle"></i>
                    </span>
                </template>

                <template #cell-recogida="{ row }">
                    <span v-if="row.pivot && row.pivot.recogida" class="tw:text-green-600">
                        <i class="fas fa-check-circle"></i>
                    </span>
                    <span v-else class="tw:text-red-500">
                        <i class="fas fa-times-circle"></i>
                    </span>
                </template>

                <template #cell-observaciones="{ row }">
                    <p class="tw:text-gray-600 tw:text-sm">{{ row.pivot ? row.pivot.observaciones : '-' }}</p>
                </template>

                <template #cell-opciones="{ row }">
                    <Button
                        @click="$emit('editar-indumentaria', row)"
                        variant="primary"
                        class="tw:text-xs tw:sm:text-sm"
                    >
                        Editar
                    </Button>
                </template>
            </SimpleTable>

            <div v-if="nombre || numero" class="tw:border-t tw:border-gray-100 tw:pt-4 tw:space-y-2">
                <p class="tw:text-sm tw:font-semibold tw:text-gray-700">
                    Nombre en camiseta: <span class="tw:font-normal tw:text-gray-600">{{ nombre || '-' }}</span>
                </p>
                <p class="tw:text-sm tw:font-semibold tw:text-gray-700">
                    Número: <span class="tw:font-normal tw:text-gray-600">{{ numero || '-' }}</span>
                </p>
            </div>
        </div>

        <div v-else class="tw:bg-white tw:rounded-xl tw:border tw:border-gray-200 tw:p-8 tw:text-center">
            <i class="fas fa-tshirt tw:text-gray-300 tw:text-4xl tw:mb-4"></i>
            <p class="tw:text-gray-500 tw:text-sm">
                Este deportista no ha adquirido ninguna indumentaria.
            </p>
        </div>
    </div>
</template>

<script setup>
    import Button from '@/modules/admin/ui/Button.vue'
    import SimpleTable from '@/modules/admin/ui/table/SimpleTable.vue'

    defineProps({
        indumentarias: {
            type: Array,
            default: () => []
        },
        nombre: {
            type: String,
            default: ''
        },
        numero: {
            type: String,
            default: ''
        },
        defaultColWidth: {
            type: String,
            default: '140px'
        }
    })

    defineEmits(['editar-indumentaria'])

    const columns = [
        { key: 'nombre', label: 'Nombre' },
        { key: 'precio', label: 'Precio' },
        { key: 'talla', label: 'Talla' },
        { key: 'cantidad', label: 'Cantidad' },
        { key: 'incluida', label: 'Incluida' },
        { key: 'recogida', label: 'Recogida' },
        { key: 'observaciones', label: 'Observaciones' },
        { key: 'opciones', label: 'Acciones' }
    ]
</script>
